import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ForecastRoutingModule } from './forecast-routing.module';
import { ForecastPageComponent } from './pages/forecast-page/forecast-page.component';
import { PeriodBarsComponent } from './components/period-bars/period-bars.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { WeatherComponent } from '@reenstudio/app/shared/components/weather/weather.component';
import { SharedModule } from '@reenstudio/app/shared/shared.module';
import { ForecastLinesChartComponent } from './components/forecast-lines/forecast-lines.component';

@NgModule({
  declarations: [
    ForecastPageComponent,
    PeriodBarsComponent,
    ForecastLinesChartComponent,
  ],
  imports: [
    CommonModule,
    ForecastRoutingModule,
    MatCardModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    NgApexchartsModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    MatProgressBarModule,
    WeatherComponent,
    SharedModule,
  ],
})
export class ForecastModule {}
